//@flow

import theme from "../Theme"
import Error from "./Error"

const Warn = Error.extend`
    color: ${props => props.theme.warning};
`

Warn.defaultProps = { theme }

export default Warn



// WEBPACK FOOTER //
// ./src/UI/Form/Warn.js